import SearchableCountrySelect from "../../../components/SearchableCountrySelect";
import { useRegister } from "../RegisterContext";
import { useTranslation } from "react-i18next";


export default function FanForm() {
  const {
    handleChange,
    handleDetailsChange,
    formData,
    fieldErrors,
    details,
    PHONE_RULES,
    passwordStrength,
    countries
  } = useRegister();

  const { t } = useTranslation();
  const getCountryTranslation = (country) => {

    return t(
      `athleteForm.${country.toLowerCase()}`
    );

  };

  return (
    <form
      id="register-step-form"
      className="register-form-grid"
    >
      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.username
            ? "input-error"
            : ""
            }`}
          name="username"
          value={formData.username || ""}
          placeholder={t("athleteForm.username")}
          onChange={handleChange}
        />

        {fieldErrors.username && (
          <div className="error-message">
            <span className="error-icon">
              ✖
            </span>
            {fieldErrors.username}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="lastname"
        value={formData.lastname || ""}
        placeholder={t("athleteForm.lastname")}
        onChange={handleChange}
      />

      <input
        required
        className="register-inputs"
        name="firstname"
        value={formData.firstname || ""}
        placeholder={t("athleteForm.firstname")}
        onChange={handleChange}
      />

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.email
            ? "input-error"
            : ""
            }`}
          name="email"
          type="email"
          autoComplete="new-email"
          value={formData.email || ""}
          placeholder={t("athleteForm.email")}
          onChange={handleChange}
        />

        {fieldErrors.email && (
          <div className="error-message">
            <span className="error-icon">
              ✖
            </span>
            {fieldErrors.email}
          </div>
        )}
      </div>

      <div className="input-wrapper">
        <input
          className={`register-inputs ${fieldErrors.password
            ? "input-error"
            : passwordStrength.valid
              ? "input-success"
              : ""
            }`}
          type="password"
          name="password"
          autoComplete="new-password"
          placeholder={t("athleteForm.password")}
          value={formData.password || ""}
          onChange={handleChange}
        />

        {formData.password && (
          <>
            <div className="password-strength-bar">
              <span
                style={{
                  width: `${passwordStrength.score * 20}%`,
                }}
                className={
                  passwordStrength.score <= 2
                    ? "weak"
                    : passwordStrength.score <= 4
                      ? "medium"
                      : "strong"
                }
              />
            </div>

            <small className="password-message">
              {passwordStrength.message}
            </small>
          </>
        )}
      </div>

      <div className="input-wrapper">
        <label className="register-date-label" htmlFor="fan-birthdate">
          {t("athleteForm.birthdate")}
        </label>
        <input
          id="fan-birthdate"
          className={`register-inputs ${fieldErrors.birthdate ? "input-error" : ""}`}
          type="date"
          name="birthdate"
          value={formData.birthdate || ""}
          onChange={handleChange}
          required
        />

        {fieldErrors.birthdate && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.birthdate}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        name="address"
        value={formData.address || ""}
        placeholder={t("athleteForm.address")}
        onChange={handleChange}
      />

      <input
        required
        className="register-inputs"
        name="postal_code"
        value={formData.postal_code || ""}
        placeholder={t("athleteForm.postalCode")}
        onChange={handleChange}
      />

      <SearchableCountrySelect
        required
        className="register-select"
        name="country"
        value={formData.country || ""}
        onChange={handleChange}
      >
        <option value="">{t("athleteForm.country")}</option>
        {countries.map((country) => (
          <option
            key={country.code}
            value={country.name}
          >
            {country.flag} {country.name}
          </option>
        ))}
      </SearchableCountrySelect>

      <select
        required
        className="register-select"
        name="language"
        value={formData.language}
        onChange={handleChange}
      >

        <option value="">
          {t("athleteForm.language")}
        </option>

        <option value="fr">
          🇫🇷 Français
        </option>

        <option value="en">
          🇬🇧 English
        </option>

        <option value="ar">
          🇲🇦 العربية
        </option>

        <option value="es">
          🇪🇸 Español
        </option>
        <option value="pt">🇵🇹 Português</option>
        <option value="zh">🇨🇳 中文（简体）</option>
        <option value="de">🇩🇪 Deutsch</option>
        <option value="ru">🇷🇺 Русский</option>
        <option value="it">🇮🇹 Italiano</option>
        <option value="sr">🇷🇸 Srpski</option>

      </select>

      <div className="input-wrapper">
        <input
          required
          className={`register-inputs ${fieldErrors.phone ? "input-error" : ""
            }`}
          name="phone"
          value={formData.phone || ""}
          placeholder={
            PHONE_RULES[formData.country]?.placeholder ||
            t("athleteForm.phone")
          }
          onChange={handleChange}
        />

        {fieldErrors.phone && (
          <div className="error-message">
            <span className="error-icon">✖</span>
            {fieldErrors.phone}
          </div>
        )}
      </div>

      <input
        required
        className="register-inputs"
        placeholder={
          t("fanForm.profession")
        }
        name="profession"
        value={details.profession || ""}
        onChange={handleDetailsChange}
      />



      <select
        required
        className="register-select"
        name="status"
        value={details.status || ""}
        onChange={handleDetailsChange}
      >

        <option value="">
          {t("fanForm.status")}
        </option>

        <option value="clubSupporter">
          {t("fanStatus.clubSupporter")}
        </option>

        <option value="athleteFan">
          {t("fanStatus.athleteFan")}
        </option>

        <option value="communityCreator">
          {t("fanStatus.communityCreator")}
        </option>

        <option value="communityMember">
          {t("fanStatus.communityMember")}
        </option>

        <option value="collector">
          {t("fanStatus.collector")}
        </option>

        <option value="observer">
          {t("fanStatus.observer")}
        </option>

      </select>

      <select
        required
        className="register-select"
        name="category"
        value={details.category || ""}
        onChange={handleDetailsChange}
      >

        <option value="">
          {t("fanForm.category")}
        </option>

        <option value="casual">
          {t("fanCategory.casual")}
        </option>

        <option value="engaged">
          {t("fanCategory.engaged")}
        </option>

        <option value="ultra">
          {t("fanCategory.ultra")}
        </option>

        <option value="leader">
          {t("fanCategory.leader")}
        </option>

        <option value="official">
          {t("fanCategory.official")}
        </option>

      </select>
    </form>
  );
}
